var product_custom_cuff = {
  first: false,
  scale: undefined,
  canvas: undefined,
  ctx: undefined,
  curve: undefined,
  curveText: undefined
};

$(document).ready(function() {
  customSwitcherBox.initEngravingFontChooser();
         product_custom_cuff.curveText = document.querySelector('.charm-letter-input');         
  product_custom_cuff.first = true;

  var productImage = document.getElementsByClassName('Product__Gallery')[0];
  if ($(".productMainImages").hasClass("engrave-c-cuff") || $(".Product__Gallery").hasClass("engrave-charm") || $(".productMainImages").hasClass("engrave-necklace")  ){
      //$(productImage).on('load', function() {
    startIt(productImage);
  //});
      
      }

    $('.charm-letters label').click(function(e) {
      console.log("click")
      $('.charm-letters input').removeClass("selected-charm");
            $(this).parent().find(".charm-letter-input").addClass("selected-charm");
      
      product_custom_cuff.curveText = document.querySelector(".selected-charm");
      		$('#engraving-charm').val($('.selected-charm').val())
    drawStack();
  });
  console.log("running")
  drawStack();
});
function startIt(productImage) {
  
  let canvasDiv = document.getElementById('canvasDiv');
  //canvasDiv.innerHTML = '<canvas id="layer0" width="' + productImage.naturalWidth + '" height="' + productImage.naturalHeight + '"></canvas>'; //for IE
  if($(".Product__Gallery").hasClass("engrave-coords")) {
    canvasDiv.innerHTML = '<canvas id="layer0" width="800" height="800"></canvas>';
    
  } else {
    canvasDiv.innerHTML = '<canvas id="layer0" width="1000" height="1000"></canvas>';
    
  }
   //for IE
  product_custom_cuff.canvas = document.getElementById('layer0');
  product_custom_cuff.ctx = product_custom_cuff.canvas.getContext('2d');
  product_custom_cuff.ctx.fillStyle = "#000";
  //product_custom_cuff.curve = "50,228,100,260,270,260,330,240";// <-- only work with canvas 400x400
  if($(".Product__Gallery").hasClass("engrave-necklace")) {
   product_custom_cuff.curve = [400, 490, 400, 550, 400, 600, 400, 680];
    
  } else {
    product_custom_cuff.curve = [150, 590, 325, 650, 650, 650, 825, 600];
    
  }

// <-- only work with canvas 1000x1000
  
  // this code can be used to calc new numbers, if you resize the canvas
  /*let canvasSize = parseInt($('#layer0').attr('width'));// width and height is assumed to be the same
  product_custom_cuff.curve = product_custom_cuff.curve.map(num => {
    return (canvasSize/400) * num
  });
  console.log(product_custom_cuff.curve)
  */
  
  product_custom_cuff.scale = 1;//productImage.naturalWidth / 400;


  //$(curveOffset).on('change', changeCurve);
  //$(fontSize).on('change', changeCurve);


  if (product_custom_cuff.first) {
    changeCurve(product_custom_cuff.ctx, product_custom_cuff.curve);
    product_custom_cuff.first = false;
  }

}
function changeCurve(ctx, curve, curveOffset, curveOffsetX, fontSize = 36) {
  if ($(".product-main-images").hasClass("engrave-chain")){
		curveOffset = -216;
    	curveOffsetX = -30;
  } else if ($(".product-main-images").hasClass("engrave-necklace")){
		curveOffset = 12;
    	curveOffsetX = 2;
  } else {
		curveOffset = 16;
        curveOffsetX = 0;
  }
  product_custom_cuff.points = curve;
  product_custom_cuff.offset = (parseInt(curveOffset) || 0);
  product_custom_cuff.offsetX = (parseInt(curveOffsetX) || 0);
  product_custom_cuff.fontSize = fontSize;
  

  if (product_custom_cuff.points.length == 8) {
    drawStack();
  }

}

function drawStack() {
  let {
    scale,
    canvas,
    ctx,
    curveText,
    points,
    offset,
    offsetX
  } = product_custom_cuff
  
  Ribbon = {
    maxChar: 50,
    startX: (points[0] - offsetX) * scale,
    startY: (points[1] - offset) * scale,
    control1X: (points[2] - offsetX) * scale,
    control1Y: (points[3] - offset) * scale,
    control2X: (points[4] - offsetX) * scale,
    control2Y: (points[5] - offset) * scale,
    endX: (points[6] - offsetX) * scale,
    endY: (points[7] - offset) * scale
  };

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.save();
  ctx.beginPath();

  ctx.moveTo(Ribbon.startX, Ribbon.startY);
  ctx.bezierCurveTo(Ribbon.control1X, Ribbon.control1Y,
    Ribbon.control2X, Ribbon.control2Y,
    Ribbon.endX, Ribbon.endY);

  //ctx.stroke();
  ctx.restore();
    var mobVariantImgId = $('.slick-current .product-variant-image').data("image-id");
  	var deskVariantImgId = $('.product-variant-image.selected').data("image-id");
  	var mattColorImgIds = [16640780828733, 16643170762813, 16643167715389, 16643110273085, 16643110633533, 16642393833533, 16643086024765, 16642403401789, 16643086057533];  
  
    console.log("Desktop img id", deskVariantImgId);
    console.log("Matt color img ids", mattColorImgIds);
    console.log(mattColorImgIds.indexOf(deskVariantImgId) > -1);
  if(mobVariantImgId == "16643167813693" || deskVariantImgId == "16643167813693") {
    product_custom_cuff.ctx.fillStyle = "#8b8b8b";
      console.log("This is a Black cuff");
      
  } else if(mobVariantImgId == "16643110305853" || deskVariantImgId == "16643110305853") {
    
    product_custom_cuff.ctx.fillStyle = "#8b8b8b";
    console.log("This is a black necklace");
  } else if(mattColorImgIds.indexOf(mobVariantImgId) > -1 || mattColorImgIds.indexOf(deskVariantImgId) > -1) {
    console.log("This is a normal cuff");
    product_custom_cuff.ctx.fillStyle = "#626262";
  } else  {
    console.log("This is a normal cuff");
    product_custom_cuff.ctx.fillStyle = "#383836";
  }
    
  if ($(".Product__Gallery").hasClass("engrave-coin")){
    product_custom_cuff.fontSize = 70;
    product_custom_cuff.offset = -222;
    product_custom_cuff.offsetX = -26;
  } else if ($(".Product__Gallery").hasClass("engrave-coin-necklace")){
    product_custom_cuff.fontSize = 76;
    product_custom_cuff.offset = -167;
    product_custom_cuff.offsetX = -26;
  } else if ($(".Product__Gallery").hasClass("engrave-coin-string")){
    product_custom_cuff.fontSize = 70;
    product_custom_cuff.offset = -180;
    product_custom_cuff.offsetX = -28;
  } else if ($(".Product__Gallery").hasClass("engrave-coin-bracelet")){
    product_custom_cuff.fontSize = 76;
    product_custom_cuff.offset = -215;
    product_custom_cuff.offsetX = 2;
  }
  else if ($(".Product__Gallery").hasClass("engrave-signet-ring")){
    product_custom_cuff.fontSize = 126;
    product_custom_cuff.offset = 20;
    product_custom_cuff.offsetX = -10;
  }
  
   if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-handwriter")){
     if ($('.Product__Gallery').hasClass("engrave-signet-ring")){
       ctx.font = "400 " + parseInt(product_custom_cuff.fontSize - 40) * product_custom_cuff.scale + "px Engraving Handwriting";
     } else {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Engraving Handwriting";
     
   }
    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-standard")) {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Engraving Standard";
    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-oldLondon")) {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Engraving Old London";
    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-typewriter")) {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Engraving Typewriter";
    } else {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Courier New";
      
    }

  if (document.querySelector(".Product__Gallery").classList.contains("engrave-coords")) {
    console.log(true);
    let curveCoordsOne = document.getElementById('latitude').value;
  	let curveCoordsTwo = document.getElementById('longtitude').value;
    let curveCoords = curveCoordsOne + "  " + curveCoordsTwo;
    FillRibbon(curveCoords, Ribbon);
  } else {
    FillRibbon(curveText.value, Ribbon);
    console.log(curveText.value);
  }

}
function FillRibbon(text, Ribbon) {
  let ctx = product_custom_cuff.ctx;
  console.log(text);
  var textCurve = [];
  var ribbon = text.substring(0, Ribbon.maxChar);
  var curveSample = 1000;


  xDist = 0;
  var i = 0;
  for (i = 0; i < curveSample; i++) {
    a = new bezier2(i / curveSample, Ribbon.startX, Ribbon.startY, Ribbon.control1X, Ribbon.control1Y, Ribbon.control2X, Ribbon.control2Y, Ribbon.endX, Ribbon.endY);
    b = new bezier2((i + 1) / curveSample, Ribbon.startX, Ribbon.startY, Ribbon.control1X, Ribbon.control1Y, Ribbon.control2X, Ribbon.control2Y, Ribbon.endX, Ribbon.endY);
    c = new bezier(a, b);
    textCurve.push({
      bezier: a,
      curve: c.curve
    });
  }
 /* if ($().hasClass("engrave-chain")){
    letterPadding = ctx.measureText("").width / 2; 
    
  } else {
    
  }*/
     if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-handwriter")){
      letterPadding = ctx.measureText(" ").width / 4;
    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-standard")) {
      letterPadding = ctx.measureText(" ").width / 4;

    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-oldLondon")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else if ($('.engrave-font-chooser-item.font-selected').hasClass("font-chooser-typewriter")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else {
      ctx.font = "400 " + parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale + "px Courier New";
      letterPadding = ctx.measureText(" ").width / -6;
    }  
  
  w = ribbon.length;
  ww = Math.round(ctx.measureText(ribbon).width);


  totalPadding = (w - 1) * letterPadding;
  totalLength = ww + totalPadding;
  p = 0;

  cDist = textCurve[curveSample - 1].curve.cDist;

  z = (cDist / 2) - (totalLength / 2);

  for (i = 0; i < curveSample; i++) {
    if (textCurve[i].curve.cDist >= z) {
      p = i;
      break;
    }
  }

  for (i = 0; i < w; i++) {
    ctx.save();
    ctx.translate(textCurve[p].bezier.point.x, textCurve[p].bezier.point.y);
    ctx.rotate(textCurve[p].curve.rad);
    ctx.fillText(ribbon[i], 0, 0);
    ctx.restore();

    x1 = ctx.measureText(ribbon[i]).width + letterPadding;
    x2 = 0;
    for (j = p; j < curveSample; j++) {
      x2 = x2 + textCurve[j].curve.dist;
      if (x2 >= x1) {
        p = j;
        break;
      }
    }




  }
} //end FillRibon

function bezier(b1, b2) {
  //Final stage which takes p, p+1 and calculates the rotation, distance on the path and accumulates the total distance
  this.rad = Math.atan(b1.point.mY / b1.point.mX);
  this.b2 = b2;
  this.b1 = b1;
  dx = (b2.x - b1.x);
  dx2 = (b2.x - b1.x) * (b2.x - b1.x);
  this.dist = Math.sqrt(((b2.x - b1.x) * (b2.x - b1.x)) + ((b2.y - b1.y) * (b2.y - b1.y)));
  xDist = xDist + this.dist;
  this.curve = {
    rad: this.rad,
    dist: this.dist,
    cDist: xDist
  };
}

function bezierT(t, startX, startY, control1X, control1Y, control2X, control2Y, endX, endY) {
  //calculates the tangent line to a point in the curve; later used to calculate the degrees of rotation at this point.
  this.mx = (3 * (1 - t) * (1 - t) * (control1X - startX)) + ((6 * (1 - t) * t) * (control2X - control1X)) + (3 * t * t * (endX - control2X));
  this.my = (3 * (1 - t) * (1 - t) * (control1Y - startY)) + ((6 * (1 - t) * t) * (control2Y - control1Y)) + (3 * t * t * (endY - control2Y));
}

function bezier2(t, startX, startY, control1X, control1Y, control2X, control2Y, endX, endY) {
  //Quadratic bezier curve plotter
  this.Bezier1 = new bezier1(t, startX, startY, control1X, control1Y, control2X, control2Y);
  this.Bezier2 = new bezier1(t, control1X, control1Y, control2X, control2Y, endX, endY);
  this.x = ((1 - t) * this.Bezier1.x) + (t * this.Bezier2.x);
  this.y = ((1 - t) * this.Bezier1.y) + (t * this.Bezier2.y);
  this.slope = new bezierT(t, startX, startY, control1X, control1Y, control2X, control2Y, endX, endY);

  this.point = {
    t: t,
    x: this.x,
    y: this.y,
    mX: this.slope.mx,
    mY: this.slope.my
  };
}

function bezier1(t, startX, startY, control1X, control1Y, control2X, control2Y) {
  //linear bezier curve plotter; used recursivly in the quadratic bezier curve calculation
  this.x = ((1 - t) * (1 - t) * startX) + (2 * (1 - t) * t * control1X) + (t * t * control2X);
  this.y = ((1 - t) * (1 - t) * startY) + (2 * (1 - t) * t * control1Y) + (t * t * control2Y);

}
